import { render, staticRenderFns } from "./SuccessiveSteps2.vue?vue&type=template&id=6fd246a6&scoped=true&"
import script from "./SuccessiveSteps2.vue?vue&type=script&lang=js&"
export * from "./SuccessiveSteps2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd246a6",
  null
  
)

export default component.exports